import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SideBar',{attrs:{"bar_name":"Redeemed Transactions","user":_vm.user}}),_c(VMain,[_c(VContainer,[_c('Tab',{attrs:{"tabs":_vm.tabs},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('AgentTransaction',_vm._b({},'AgentTransaction',{ user: slotProps.user, tabId: slotProps.tabId, tabName: slotProps.tabName },false))]}}])})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }